<script setup lang="ts">
import type { Component } from 'vue';

interface Props {
  icon: Component;
  variant?: 'primary' | 'secondary' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

withDefaults(defineProps<Props>(), {
  variant: 'secondary',
  size: 'md',
});

const emit = defineEmits({
  click: () => true,
});

const variantClasses = {
  primary: 'bg-(--color-primary) text-white hover:bg-opacity-90',
  secondary: 'bg-white/80 text-[var(--color-foreground)] hover:bg-white',
  danger: 'bg-[var(--color-destructive)] text-white hover:bg-opacity-90',
};

const sizeClasses = {
  sm: 'p-1.5',
  md: 'p-2',
  lg: 'p-3',
};

const iconSize = (size: string) => {
  if (size === 'sm') return 14;
  if (size === 'lg') return 22;
  return 18;
};
</script>

<template>
  <button
    @click="emit('click')"
    :class="[
      'rounded-md transition-all duration-200 shadow-sm hover:shadow-md flex items-center gap-2 cursor-pointer',
      variantClasses[variant],
      sizeClasses[size],
    ]"
    :aria-label="label"
  >
    <component :is="icon" :size="iconSize(size)" />
    <span v-if="label" class="text-sm font-medium">{{ label }}</span>
  </button>
</template>
